<template>
  <div role="group" class="mb-3">
    <b-form-group :label="question">
      <b-form-tags v-model="answer"></b-form-tags>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "AccountArray",
  props: {
    body: {
      type: Object,
      default() {
        return {};
      },
    },
    question: {
      type: String,
      default: "",
    },
    preAnswer: {
      type: String,
      default: "",
    },
    answerList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      answer: [],
    };
  },
  mounted() {
    this.answer = this.preAnswer.split(",");
    this.$emit("load-next", this.body.next);
  },
};
</script>

<style></style>
